module.exports = __webpack_public_path__ + "img/integration-module-2.80336705.png";